export default {
  success: '#00b398',
  primary: '#0072bc',
  danger: '#eb4034',
  lightGrey: '#bab8b8',
  white: '#f7f7f7',
};
